import React from 'react';
import './ErrorBoundary.css';
/**
 * Renders component with API error or Web App error messages
 *
 * @param {string} [className] - the CSS classname
 * @param {boolean} showError - state which determines if an error message will be displayed
 * @param {React.ReactNode} children - the error message it can be string or react child with string
 * @param {string} [style] - the CSS style for error message 'primary' | 'secondary'
 * @param {string} [status] - the status of message 'warning' | 'error'
 *
 * @example
 * <ErrorBoundary className='a6y-react-auth__error-boundary' showError={true}>
 *    Error message or React child with message
 * </ErrorBoundary>
 */
var ErrorBoundary = function (_a) {
    var _b;
    var _c = _a.className, className = _c === void 0 ? 'a6y-react-auth__error-boundary' : _c, _d = _a.showError, showError = _d === void 0 ? false : _d, _e = _a.children, children = _e === void 0 ? 'Ups! Something were wrong' : _e, _f = _a.style, style = _f === void 0 ? 'primary' : _f, _g = _a.status, status = _g === void 0 ? 'error' : _g;
    var classNames = require('classnames');
    var ErrorBoundaryClass = classNames((_b = {},
        _b[className + "--" + style] = showError && style ? true : false,
        _b[className + "--" + status] = showError && status ? true : false,
        _b));
    return (React.createElement("div", { className: className + ' ' + ErrorBoundaryClass }, showError && children));
};
export default ErrorBoundary;
//# sourceMappingURL=ErrorBoundary.js.map